module.exports = __webpack_public_path__ + "img/fail.fd1db1aa.png";